<template>
  <l-upload class="avatar-uploader" :on-success="handleAvatarSuccess" :show-file-list="false" v-bind="$attrs" v-on="$listeners">
    <div v-loading="loading">
      <img v-if="preview_url" :src="preview_url" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </div>
  </l-upload>
</template>

<script>
import Upload from "./Upload.vue";
export default {
  name: "l-upload-img",
  components: {
    [Upload.name]: Upload,
  },
  props: {
    onSuccess: {
      type: Function,
      default: null,
    },
    previewUrl: {
      type: String,
      default: null,
    },
    limitSize: {
      type: [String, Number],
      default: 15,
    },
  },

  watch: {
    previewUrl(val) {
      this.preview_url = val;
    },
  },

  data() {
    return {
      preview_url: "",
      loading: false,
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      //this.preview_url = res.data.preview_url;

      this.loading = false;
      if (this.$props.onSuccess !== null) {
        this.onSuccess(res, file);
      }
      //this.$emit('on-success', res);
      // // console.log(res);
      // // console.log(file)
      this.preview_url = URL.createObjectURL(file.raw);
    },

    clearImg() {
      this.preview_url = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader {
  .el-upload:hover {
    border-color: #409eff;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 108px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 108px;
  height: 100px;
  display: block;
}
</style>